module.exports = __webpack_public_path__ + "static/forecast/weather/nightcloud-4d12c4b708102e47b40c4f0685fd0a4e.svg";